import Vue from 'vue'
import fileDownload from 'js-file-download'
import { prepareFailedResponse } from 'w3box-vue-api'

export default {
  download: year => new Promise((resolve, reject) => {
    return Vue.http.get(`/api/export/${year}`, {responseType: 'blob'}).then(
      response => {
        const filename = response.headers.get('content-disposition').replace(/attachment; filename=(.*)/, "$1")
        fileDownload(response.body, filename)
        resolve(response.body)
      },
      response => reject(prepareFailedResponse(response))
    )
  }),
  getExports: () => new Promise((resolve, reject) => {
    return Vue.http.get(`/api/export`).then(
      response => resolve(response.body),
      response => reject(prepareFailedResponse(response))
    )
  }),
  getWeek: week => new Promise((resolve, reject) => {
    return Vue.http.get(`/api/week/${week}`).then(
      response => resolve(response.body),
      response => reject(prepareFailedResponse(response))
    )
  }),
  updateTasks: tasks => new Promise((resolve, reject) => {
    tasks = tasks.map(item => {
      if(item.id && typeof item.id.match == 'function' && item.id.match(/^\$uid/))
      {
        delete item.id
      }
      return item
    })
    return Vue.http.put(`/api/tasks`, tasks).then(
      response => resolve(response.body),
      response => reject(prepareFailedResponse(response))
    )
  }),
}
